export default __webpack_public_path__ + "static/exp6-7944b876a5b9061940e3b7afcc43227d.webp";